import React from 'react';

export type DriveEmptyStateProps = {
  icon?: React.ReactNode;
  title: string;
  description: string;
};

const DriveEmptyState: React.FC<DriveEmptyStateProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 px-4">
      {icon && (
        <div className="mb-2 rounded-[4px] bg-[#F5F5F5] p-2">
          {icon}
        </div>
      )}
      <h3 className="text-base font-semibold text-gray-800 mb-1 text-center">
        {title}
      </h3>
      <p className="text-sm text-gray-600 text-center max-w-sm">
        {description}
      </p>
    </div>
  );
};

export default DriveEmptyState;
